// custom javascript 2

function checkWindowsSize(breackpoint) {
	if (window.matchMedia("(max-width: " + breackpoint + "px)").matches) {
		//alert("The viewport is less than, or equal to, "+breackpoint+" pixels wide");
		return true;
	} else {
		//alert("The viewport is greater than, "+breackpoint+" pixels wide");
		return false;
	}
}


// comprueva la medida del navegador
function checkMenuCollapsed(check, menu) {
	if (check) {
		menu.css('display', 'none');
	} else {
		menu.css('display', 'block');
	}
}

// delete elements from DOOM
function deleteElementsDOM() {
	//style="clear: left; height: 1px;"
	$('div[style="clear: left; height: 1px;"], div[class="brcm-clear"]').remove();
}


// function that replace 0,00€ by Consultar Precio
function getLanguage(){
	return document.documentElement.lang;
}


// repara flexslider añadiendo wrappers
function repairFlexslider() {
	// repair caption flexslider
	var slides = $('.brcm-generic-slider .brcm-image');
	slides.each(function () {

		var text = $(this).find('.brcm-flexslider-caption').text();

		if (text.length == 0) {
			$(this).find('.brcm-flexslider-caption').remove();
		} else {
			$(this).find('.brcm-flexslider-caption').wrap('<div class="container-caption container" />');
		}


		//$(this).find('.brcm-flexslider-caption').wrap('<div class="container" />');
	});
}


// fix videos

// function fixVideosYoutube() {
// 	// Find all YouTube videos
// 	// https://css-tricks.com/NetMag/FluidWidthVideo/Article-FluidWidthVideo.php
//
// //    var $allVideos = $("iframe[src^='//www.youtube.com']"),
// 	var $allVideos = $("figure iframe"),
//
// 		// The element that is fluid width
// 		$fluidEl = $("figure");
//
// 	// Figure out and save aspect ratio for each video
// 	$allVideos.each(function () {
//
// 		var newWidth = $fluidEl.width();
//
// 		$(this).data('aspectRatio', (16 / 9))
// 			// and remove the hard coded width/height
// 			.removeAttr('height')
// 			.removeAttr('width');
//
// 	});
//
//
// 	// When the window is resized
// 	$(window).resize(function () {
//
// 		var newWidth = $fluidEl.width();
//
// 		// Resize all videos according to their own aspect ratio
// 		$allVideos.each(function () {
//
// 			var $el = $(this);
// 			$el
// 				.width(newWidth)
// 				.height(newWidth * $el.data('aspectRatio'));
//
// 		});
//
// 		// Kick off one resize to fix all videos on page load
// 	}).resize();
//
// }


// funcion para crear titulos de youtube

function getYoutubeId(src) {
	//https://ctrlq.org/code/19797-regex-youtube-id
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
	var match = src.match(regExp);
	return (match[7]);
}


function getYoutubeTitle(wrapperCss) {
	//alert (wrapperCss);

	var containersVideos = $(wrapperCss);

	containersVideos.each(function(){

		var iframe = $(this).find('iframe');

		var src = iframe.attr('src');

		var id = getYoutubeId(src);

		var url = 'https://www.youtube.com/watch?v=' + id;


		var containerYoutube = $(this);

		$.getJSON('https://noembed.com/embed',
			{format: 'json', url: url}, function (data) {

				containerYoutube.after('<figcaption class="youtubeCaption">' + data.title + '</figcaption>');
			});

	});
}


// convertir galaeria en pase de diapositivas

function galeryConvertToCarrousel(wrapperGaleria) {
	var galeria = $(wrapperGaleria);

	// limpiar html tonto
	galeria.find('div[style="clear: left; height: 1px;"], div[class="brcm-clear"]').remove();

	//Arreglamos imagenes
	var images = galeria.find('img');
	images.each(function () {
		var srcImg = $(this).attr('src');
		srcImg = srcImg.split('?')[0];
		$(this).attr('src', srcImg);

		if ($(this).parent().is("a")) {
			$(this).unwrap();
		}
	});

	// convertimos en flexslider

	// añadimos classe flexslider
	//galeria.parent().addClass('flexslider').attr('id', 'flexslider-galeria');
	galeria.parent().attr('id', 'flexslider-galeria');
	//creamos carrousel
	var carrousel = $('<div/>', {
		'id': 'carrousel-galeria',
		//'class': 'flexslider',
	});

	carrousel.append($("<ul/>", {
		'class': 'slides'
	}));


	// elementos lista
	var slides = galeria.find('.brcm-image-and-caption');
	slides.each(function () {

		var imgUrl = $(this).find('img').attr('src') + "?amplada-maxima=150";

//    $(this).replaceWith($('<li class="brcm-image-and-caption slide" data-thumb="'+imgUrl+'">' + this.innerHTML + '</li>'));
		$(this).replaceWith($('<li class="brcm-image-and-caption slide">' + this.innerHTML + '</li>'));

		// creamos miniaturas
		carrousel.find('.slides').append($('<li><img src="' + imgUrl + '" /></li>'))
	});

//http://etr.brancam.com/imatge/178/demoGaleria_02.jpg?amplada-maxima=150


	// insertamos carrousel
	galeria.parent().after(carrousel);

	// envoltorio lista
	galeria.replaceWith(function () {
		return $('<ul/>', {
			html: $(this).html(),
			class: "brcm-gallery-of-images slides"
		});
	});


} // galeryConvertToCarrousel(wrapperGaleria)


// images class

function checkImages(searchWord) {
	var elementsImages = $('[class^="' + searchWord + '"]');

	elementsImages.each(function () {
		$(this).addClass('display');

		if ($(this).find('.brcm-group-of-images img').length > 0) {
			$(this).addClass('with-images');
		}
	});
}


// repair-transform news module

//
function newsListTransformation() {
	var news = $('.brcm-list-of-news li');
	news.each(function () {
		$(this).wrapInner('<div class="news-summary" />');

		if ($(this).find('.brcm-image-and-caption').length) {
			$(this).find('.brcm-image-and-caption').prependTo($(this));
		} else {
			$(this).prepend('<div class="no-image" />');
			$(this).addClass('noImage')
		}

		$(this).find('.brcm-date').prependTo($(this));

		$(this).addClass('visible');
	});
}


//
function newsDetailTransformation() {
	var detailNew = $('.brcm-news-module');

	//detailNew.find('.brcm-news-detail').wrapInner('<div class="detail-container" />');
	detailNew.find('.brcm-group-of-images').prependTo(detailNew);

	detailNew.find('.brcm-date').appendTo('#article-header');

	detailNew.find('.brcm-summary').appendTo('#article-header');

	// repair attachments
	// replace tag
	detailNew.find('h2:not(.brcm-body h2)').replaceWith(function () {
		return $('<h4/>', {
			html: this.innerHTML
		})
	}).addClass('list-attachemnt-title');
	// move on commmon wrapper
	detailNew.find('h4:not(.brcm-body h4)').addClass('list-attachemnt-title');
	detailNew.find('.list-attachemnt-title, .brcm-list-of-attachments').wrapAll( "<div class='attachments-wrapper'></div>" );
	detailNew.addClass('visible');
}


// media gallery transform

function mediaGalleryTransform() {

	var gallery = $('div.brcm-pagina-element[data-brcm-type="Pagina_Element_Galeria"]');

	// transform

	var galleries = gallery.find('.brcm-image-and-caption');

	galleries.each(function () {

		// transform image
		$(this).find('img').wrap('<figure />');

		// transform caption
		var caption = $(this).find('.brcm-caption');
		$(this).find('.brcm-image a').append('<figcaption class="caption">' + caption.text() + '</figcaption>');
		caption.remove();


	});


	// show
	gallery.addClass('visible');
}


// Function to convert localNavigation() to Tab, needs CSS
function transformToTab() {

	var tabMenuWrapper = $('#tab-navigation');

	var tabMenu = tabMenuWrapper.find('.brcm-active-node ul');

	if (tabMenu.length == 0) {
		tabMenuWrapper.remove();
	} else {
		tabMenuWrapper.find('.brcm-navigation').remove();
		tabMenuWrapper.append(tabMenu);
		tabMenuWrapper.addClass('visible')
	}
}


// transform clipping

function transformClipping() {

	var clippingElements = $('body.media div[data-brcm-type="PaginaElementAdjunts"]');

	if (clippingElements.length != 0) {
		//var clippingItem = clippingElements.find
		clippingElements.find('a').wrapInner('<span class="title-item" />').append('<span class="zoom" />');


		clippingElements.addClass('visible');
	} else {
		return;
	}
}


function calculateClock(countDownDate){

	var now = new Date().getTime();
	var distance = countDownDate - now;

	document.getElementById("days").innerHTML = Math.floor(distance / (1000 * 60 * 60 * 24));
	document.getElementById("hours").innerHTML = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	document.getElementById("minutes").innerHTML = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
}


// clock
function countDown() {

	// exit function in variable is not defined
	if(typeof configuracio == 'undefined'){
		return;
	}

	// get date race
	var countDownDate = new Date(configuracio.inici).getTime();

	//exit function if time is expired
	var now = new Date().getTime();

	//exit function if time is expired
	if((countDownDate - now) < 0){
		document.getElementById("countDownContainer").innerHTML = "EXPIRED";
		return
	}

	calculateClock(countDownDate);

	// Update the count down every 1 second
	var x = setInterval(function () {
		calculateClock(countDownDate);
	}, 0, 1000);

	//show element

	$('#timer-wrapper').addClass('visible');
	//$('#timer-wrapper').css('display', 'inline-block');
}


// function for add class to element when scroll
function onScrollClass(elementCssSector, startScrollHeight){

	//scroll value
	var screenPosition = $(document).scrollTop();

	//previous class
	if(screenPosition >= (startScrollHeight-20)){
		$(elementCssSector).addClass('sticky-previous');
	} else{
		$(elementCssSector).removeClass('sticky-previous');
	}

	if(screenPosition >= startScrollHeight){
		$(elementCssSector).addClass('sticky');
	} else{
		$(elementCssSector).removeClass('sticky');
	}
}




/**
 *
 * PRODUCTS
 *
 *
 *
 */

// add class to list element that doesn't got image.

function noImageProductList(){
	var products = $('.brcm-product');

	products.each(function(){

		if($(this).find('.brcm-image-and-caption').length == 0){
			console.log('no image');
			$(this).addClass('no-image');

			$(this).prepend('<div class="brcm-image-and-caption no-image"><div class="brcm-image"></div></div>');
		}

	});

}



// function transform products
function transformProductsList(){
	var productItems = $('.brcm-list-of-products li.brcm-product');


	productItems.each( function(){
		// show elements
		$(this).addClass('visible');
	});
}




// clean HTML output of product detail
function transformProductDetail(){

	$('.brcm-product-detail .brcm-list-of-products').each(function(){
		$(this).parent('.brcm-product-detail').append(this);
		$(this).addClass('related-products');
		$(this).insertAfter($(this).parent()).addClass('visible');
	});

	// remove brancam elements not usefull
	$('.brcm-product-detail .brcm-navigation,.brcm-product-detail .clear, .brcm-product-detail .brcm-text-attributes > h2').remove();

	// change price
	$('.brcm-product-detail .brcm-text-attributes .brcm-before, .brcm-product-detail .brcm-text-attributes .brcm-now').wrapAll('<div class="brcm-price" />');

	// move header title inside text-description
	$('body.product-detail #article-header, .brcm-product-detail .brcm-form .brcm-price').prependTo('.brcm-text-attributes');

	// set related products outside brcm-product-details



	// product module
	$('.brcm-product-detail .brcm-products-module').addClass('visible');
	$('.brcm-product-detail .brcm-list-of-products').addClass('visible');
}

// add slider to product detail when it has more than one image
function sliderProducts(){

	var productsContainer = $('.brcm-product-detail > .brcm-group-of-images');
	productsContainer.attr('id', 'product-detail-flexslider');
	productsContainer.wrapInner('<div class="slides"></div>');
	productsContainer.find('.slides').append('<div class="loader"></div>');

	productsContainer.find('.brcm-image-and-caption').each(function(){
		var imageSrc = $(this).find('img').attr('src');
		imageSrc = imageSrc.split( '?' )[0];
		imageSrc = imageSrc+'?amplada-maxima=120';

		console.log(imageSrc);
		$(this).attr("data-thumb", imageSrc);
	});


	$(window).load(function() {

		$('#product-detail-flexslider').flexslider({
			selector: ".slides > .brcm-image-and-caption",
			// smoothHeight: true,
			// animation: "slide",
			//pausePlay: false,
			slideshow: false,
			controlNav: "thumbnails",
			directionNav: false,

			// prevText: "Anterior",
			// nextText: "Siguiente",
			// slideshowSpeed: 7000,
			// animationSpeed: 600
			start: function(){
				$('#product-detail-flexslider').addClass('visible');
				$('#product-detail-flexslider ol.flex-control-thumbs').addClass('visible');
				$('.brcm-products-module .brcm-list-of-products').addClass('visible');

				console.log('start flexslider');
				//$('.brcm-list-of-products h2' ).css('margin', '0');
			}
		});

	});

	//$('#product-detail-flexslider').addClass('visible');
}

// collapsed menu categories
function categoriesMenuCollapse(){
	$('#toggle-button').click(function(){
		$(this).toggleClass('opened');
		$('.categories-menu .brcm-list-of-categories').slideToggle('fast');
	});
}

// function to add class to active category menu
// needed for repair link active behavior
function checkActiveElementNavigation(parent){
	$(parent + ' .brcm-active-node > span a').last().addClass('active');
}


//
function newsListTransformation(){
	var news = $('.brcm-list-of-news li');
	news.each(function(){
		$(this).wrapInner('<div class="news-summary" />');

		if($(this).find('.brcm-image-and-caption').length){
			$(this).find('.brcm-image-and-caption').prependTo($(this));
		} else{
			$(this).prepend('<div class="no-image" />');
			$(this).addClass('noImage')
		}
		$(this).addClass('visible');
	});
}

//
function newsDetailTransformation(){
	var detailNew = $('.brcm-news-module');

	//detailNew.find('.brcm-news-detail').wrapInner('<div class="detail-container" />');
	detailNew.find('.brcm-group-of-images').prependTo(detailNew);

	detailNew.find('.brcm-date').appendTo('#article-header');

	detailNew.find('.brcm-summary').appendTo('#article-header');

	// repair attachments
	// replace tag
	detailNew.find('h2:not(.brcm-body h2)').replaceWith(function(){
		return $('<h4/>', {
			html: this.innerHTML
		})
	}).addClass('list-attachemnt-title');
	// move on commmon wrapper
	detailNew.find('h4:not(.brcm-body h4)').addClass('list-attachemnt-title');
	detailNew.find('.list-attachemnt-title, .brcm-list-of-attachments').wrapAll( "<div class='attachments-wrapper'></div>" );

	detailNew.addClass('visible');
}

//
function cartTransform(){

	var cartContainer = $('.cart-container');
	var getAmount = cartContainer.find('.brcm-cart-amount a span').html();

	var carroCompraString = cartContainer.find('.brcm-cart-items a').html();
	var totalCompraString = cartContainer.find('.brcm-cart-checkout a').html();
	var urlCart = cartContainer.find('.brcm-cart-checkout a').attr('href');

	var amount = cartContainer.find('.brcm-cart-amount span').html();
	var totalItems = cartContainer.find('.brcm-cart-total-items span').html();

	cartContainer
		.find('.brcm-cart')
		.append('<a id="cartLink" href="'+urlCart+'" title="'+carroCompraString+'">' +
			'<span class="brcm-cart-amount"><span></span>€</span>' +
			'<span class="brcm-cart-total-items"><span></span></span>' +
			'</a>');

	$('#cartLink .brcm-cart-amount span').text(amount);
	$('#cartLink .brcm-cart-total-items span').text(totalItems);

	cartContainer.find('.brcm-cart-box').remove();


	if(getAmount != '0,00'){
		cartContainer.addClass('visible');
	} else{
		$('.brcm-actions input[type="submit"]').click(function(){
			cartContainer.addClass('visible');
		});
	}
}

// repair menus
function repairMenus(){
	// get all element menus that has children
	var itemsWithSubmenus = $('.brcm-navigation li:has(ul)');

	// copy url from first children to parent
	itemsWithSubmenus.each(function(){
		var urlParent = $(this).find('ul > li:first-child a').attr('href');
		$(this).find('> span > a').attr('href', urlParent);
	});

	$('.brand-container .brcm-navigation ul ul ul, .sidebar-menu li li:not(.brcm-active-node) ul').remove();
}

//
function transformSidebarMenu() {
	var sidebarMenu = $('#sidebar-menu');

	// solo mostramos los que hijos del primer .brcm-active-node
	// eliminamos las partes del menu que sobran


	if(sidebarMenu.find('.brcm-active-node').length == 0){
		sidebarMenu.remove();
		return;
	}

	sidebarMenu.find('.brcm-navigation > ul > li:not(.brcm-active-node)').each(function(){
		$(this).remove();
	});

	// cogemos el texto del primer elemento del menu el padre para hacer titulo
	var titleSection = sidebarMenu.find('.brcm-navigation > ul > li > span').text();

	// hacemos un título
	sidebarMenu.find('.brcm-navigation').prepend('<h3 class="menu-title">'+titleSection+'</h3>');

	// extract el menu que utilizaremos
	var newMenu = sidebarMenu.find('.brcm-navigation > ul > li > ul');

	// eliminamos menu
	sidebarMenu.find('.brcm-navigation > ul').remove();
	sidebarMenu.find('.brcm-navigation').append(newMenu);

	//
	var titleCurrent = newMenu.find('li.brcm-active-node:has(li.brcm-current-node) > span').text();
	//console.log(titleCurrent.length);
	if(titleCurrent.length>0){
		$('.block-title.page-title').text(titleCurrent);
	}


	$('#sidebar-menu').addClass('visible');
}


/**
 *
 *
 *
 */

function transformRegisterBar(){

	var userMenu = $('.brcm-user-menu');


	if(userMenu.find('.brcm-account-user').length == 1){
		userMenu.addClass('visible');
	}

	// Generate output for button
	var htmlOutput = '<div class="newUserLinkContainer">';

	switch (getLanguage()){
		case 'es':
			htmlOutput += '<a href="/es/usuarios/alta" class="newUserLink">Nuevo usuario</a>';
			break;
		case 'ca':
			htmlOutput += '<a href="/ca/usuaris/alta" class="newUserLink">Nou usuari</a>';
			break;

		case 'en':
			htmlOutput += '<a href="/en/users/alta" class="newUserLink">New user</a>';
			break;
	}

	htmlOutput += '</div>';

	$('.brcm-login-ecommerce').append(htmlOutput);

	//$('#tab-login').append('<i class="icon-shopping-basket"></i>');

}


/**
 *
 */

// hide cart if price is 0
// need to select brcm-cart class
function cartTransform(cartContainer){

	var cartContainer = $(cartContainer);
	var getAmount = cartContainer.find('.brcm-cart-amount a span').html();
	var carroCompraString = cartContainer.find('.brcm-cart-items a').html();
	var urlCart = cartContainer.find('.brcm-cart-checkout a').attr('href');
	var amount = cartContainer.find('.brcm-cart-amount span').html();
	var totalItems = cartContainer.find('.brcm-cart-total-items span').html();

	cartContainer
		.append('<a id="cartLink" href="'+urlCart+'" title="'+carroCompraString+'">' +
			'<span class="brcm-cart-amount"><span></span>€</span>' +
			'<span class="brcm-cart-total-items"><span></span></span>' +
			'</a>');

	$('#cartLink .brcm-cart-amount span').text(amount);
	$('#cartLink .brcm-cart-total-items span').text(totalItems);

	cartContainer.find('.brcm-cart-box').remove();

	if(getAmount != '0,00'){
		cartContainer.addClass('visible');
		// check if has class
		if(!$('.brcm-user-menu').hasClass('visible')){
			$('.brcm-user-menu').addClass('visible');
		}

		$('.brcm-user-menu').addClass('cart-not-empty');

	} else{
		$('.brcm-product-detail .brcm-actions input[type="submit"]').click(function(){
			cartContainer.addClass('visible');
			// check if has class
			if(!$('.brcm-user-menu').hasClass('visible')){
				$('.brcm-user-menu').addClass('visible');
			}

			$('.brcm-user-menu').addClass('cart-not-empty');
		});
	}
}

//
function transformSearchForm(selector){
	selector = $(selector);
	switch (getLanguage()){
		case 'es':
			selector.prepend('<label>Buscar producto</label>');
			break;
		case 'ca':
			selector.prepend('<label>Cercar producte</label>');
			break;
		case 'en':
			selector.prepend('<label>Search product</label>');
			break;
	}
	selector.addClass('visible');
}

// add class to body

function checkPageBody(){
	var url      = window.location.href;     // Returns full UR
	url = url.split("/");
	url = url.pop();
	$('body').addClass(url);
}


// A $( document ).ready() block.
$(function () {

	/*
	Add Page classes to body, easy CSS develpment
	 */
	checkPageBody();

	//
	repairMenus();

	deleteElementsDOM();

	//
	$('.main-header .navigation-container .brcm-navigation').attr('id', 'main-navigation');

	// construct menu smartmenus
	$('#main-navigation > ul').addClass('sm');
	$('#main-navigation > ul').addClass('sm-simple');
	$('#main-navigation > ul').attr('id', 'main-menu');
	//$('#main-menu').smartmenus();

	// initialize smartmenus
	$('#main-menu').smartmenus();

	// muestra el menu
	$('.main-header .navigation-container').removeClass('disabled');

	// toogle button
	$('#main-menu-state').click(function () {
		$(this).toggleClass('is-active');
		$('#main-menu').toggleClass('expanded');
		$('#main-menu').slideToggle();
	});

	var breakpoint = 992;

	checkMenuCollapsed(
		checkWindowsSize(breakpoint),
		$('#main-menu')
	);

	$(window).resize(function () {
		checkMenuCollapsed(
			checkWindowsSize(breakpoint),
			$('#main-menu')
		);
	});

	//
	galeryConvertToCarrousel('body.galeria .brcm-gallery-of-images');

	//
	getYoutubeTitle('.video-container');

	// repara el el flxslider
	repairFlexslider();

	// ajusta ancho de videos
	//fixVideosYoutube();

	//checkimages
	checkImages('brcm-generic-element-with-image');

	//
	newsListTransformation();
	newsDetailTransformation();


	//
	mediaGalleryTransform();

	//
	transformToTab();

	//
	transformClipping();

	//
	countDown();

	/*
	SHOP JAVASCRIPT TRANSFORMS
	 */

	//transformProductsList();

	categoriesMenuCollapse();

	// sidebar menus
	transformSidebarMenu();

	/*

	 */
	transformRegisterBar();

	// convert cart and show or hide if it is empty
	cartTransform('.shop-cart-menu .brcm-cart');

	transformSearchForm('.search-product-wrapper');


	/*
	*	SCROLL EFFECTS
	*
	*/

	onScrollClass('header.main-header', 200);

	$(window).scroll(function(){
		onScrollClass(
			'header.main-header',
			300);
	});


});
